import './Logo.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Logo extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        noText: PropTypes.bool
    };

    render() {
        return (
            <div className={classNames('c-logo', this.props.className, {'a-logo--no-text': this.props.noText === true})}>
                {this.props.noText === true ? (
                    <svg viewBox="0 0 40 40">
                        <path fill="#ff6850" d="M20,38A18,18,0,1,0,2,20,18,18,0,0,0,20,38Zm0,2A20,20,0,1,1,40,20,20,20,0,0,1,20,40Z"/>
                        <path fill="#ff6850" d="M20,34A14,14,0,1,0,6,20,14,14,0,0,0,20,34Zm0,2A16,16,0,1,1,36,20,16,16,0,0,1,20,36Z"/>
                        <path fill="#ff6850" d="M35.16,19.48v2H19.81v-2Z"/>
                        <path fill="#ff6850" d="M19.17,4.28h2v31.6h-2Z"/>
                        <path fill="#ff6850" d="M11.17,7.16h2v26h-2Z"/>
                    </svg>
                ) : (
                    <svg viewBox="0 0 185 40">
                        <path fill="#ff6850" d="M20,38A18,18,0,1,0,2,20,18,18,0,0,0,20,38Zm0,2A20,20,0,1,1,40,20,20,20,0,0,1,20,40Z"/>
                        <path fill="#ff6850" d="M20,34A14,14,0,1,0,6,20,14,14,0,0,0,20,34Zm0,2A16,16,0,1,1,36,20,16,16,0,0,1,20,36Z"/>
                        <path fill="#ff6850" d="M35.16,19.48v2H19.81v-2Z"/>
                        <path fill="#ff6850" d="M19.17,4.28h2v31.6h-2Z"/>
                        <path fill="#ff6850" d="M11.17,7.16h2v26h-2Z"/>
                        <path className="c-logo__text" fill="#4f535a" d="M65.43,16.22H61V27.78H58.17V16.22H53.69V13.6H65.43ZM83.55,27.78H80.77V21.9H74.58v5.88H71.82V13.6h2.76v5.7h6.18V13.6h2.78Zm16.57,0H91.24V13.6h8.89v2.6H94v3.24h5.54V21.9H94v3.28h6.12Zm28.33,0h-2.78V21.9h-6.18v5.88h-2.76V13.6h2.76v5.7h6.18V13.6h2.78Zm13,.32c-3,0-5.44-1.86-5.44-5.34V13.6h2.76v9a2.7,2.7,0,1,0,5.38,0v-9h2.76v9.16C146.9,26.24,144.48,28.1,141.44,28.1Zm25.12-.32h-2.9l-6.44-10.06V27.78h-2.76V13.6h3.44L163.8,23V13.6h2.76ZM184.7,16.22h-4.48V27.78h-2.78V16.22h-4.48V13.6H184.7Z"/>
                    </svg>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Logo/index.js